module.exports = __webpack_public_path__ + "static/media/hover_image_request.ca9b8d88.png";